export default __webpack_public_path__ + "static/media/empty-payment-info.991bbaeb.svg";